<template>
  <div id="app">
    <my-header />
    <div class="container">
      <router-view />
    </div>
  </div>
</template>

<script>
import MyHeader from '@/components/MyHeader.vue';
import WalletState from "./state/WalletState";
export default {
  name: 'App',
  components: {
    MyHeader
  },
  mounted() {
    WalletState.connetWallet();
  },
  data() {
    return {

    }
  }
}
</script>

<style lang="less">
html,
body {
  padding: 0;
  margin: 0;

  h1,
  h2,
  h3,
  h4,
  h5 {
    padding: 0;
    margin: 0;
  }

  ul,
  ol {
    list-style: none;
  }
}
</style>
